module.exports = __webpack_public_path__ + "static/media/paint.64d8856e.png";